/// <amd-module name="Artifacts/Npm/helpers/NpmDependencyHelper" />
import * as NpmRes from "Artifacts/Npm/Resources";
import { IDependencyGroup } from "Artifacts/Root/types/IDependency";

export class NpmDependencyHelper {
  public static formatGroupNames(dependencyGroups: IDependencyGroup[]): void {
    for (const dependencyGroup of dependencyGroups) {
      dependencyGroup.group = NpmDependencyHelper._getNpmGroupName(dependencyGroup.group);
    }
  }

  private static _getNpmGroupName(group: string): string {
    if (group === "peerDependencies") {
      return NpmRes.NpmDependencies_PeerDependenciesFriendly;
    } else if (group === "devDependencies") {
      return NpmRes.NpmDependencies_DevDependenciesFriendly;
    } else if (group === "optionalDependencies") {
      return NpmRes.NpmDependencies_OptionalDependenciesFriendly;
    } else if (group === "bundleDependencies") {
      return NpmRes.NpmDependencies_BundledDependenciesFriendly;
    } else if (group === "bundledDependencies") {
      return NpmRes.NpmDependencies_BundledDependenciesFriendly;
    }

    return group;
  }
}
